module.exports = __webpack_public_path__ + "img/icon-27.bfc5073f.png";